import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HomeV2 from "../pages/home-v2/page";
import HomeApps from "../pages/home-apps/page";
import HomeEcommerce from "../pages/home-ecommerce/page";
import HomeErp from "../pages/home-erp/page";

/** VITE_*_ONLY=true → نسخة واحدة على / | وإلا المسارات الفرعية */
const isAppsOnly = import.meta.env.VITE_APPS_ONLY === "true";
const isDarkOnly = import.meta.env.VITE_DARK_ONLY === "true";
const isEcommerceOnly = import.meta.env.VITE_ECOMMERCE_ONLY === "true";
const isErpOnly = import.meta.env.VITE_ERP_ONLY === "true";
const isHomeOnly = import.meta.env.VITE_HOME_ONLY === "true";

const routes: RouteObject[] = isAppsOnly
  ? [
      { path: "/", element: <HomeApps /> },
      { path: "*", element: <NotFound /> },
    ]
  : isEcommerceOnly
    ? [
        { path: "/", element: <HomeEcommerce /> },
        { path: "*", element: <NotFound /> },
      ]
    : isErpOnly
      ? [
          { path: "/", element: <HomeErp /> },
          { path: "*", element: <NotFound /> },
        ]
      : isHomeOnly
      ? [
          { path: "/", element: <Home /> },
          { path: "*", element: <NotFound /> },
        ]
      : isDarkOnly
      ? [
          { path: "/", element: <HomeV2 /> },
          { path: "*", element: <NotFound /> },
        ]
      : [
          { path: "/", element: <Home /> },
          { path: "/v2", element: <HomeV2 /> },
          { path: "/apps", element: <HomeApps /> },
          { path: "/ecommerce", element: <HomeEcommerce /> },
          { path: "/erp", element: <HomeErp /> },
          { path: "*", element: <NotFound /> },
        ];

export default routes;
